import { Fragment, useEffect, useMemo, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import { setAlert } from '../../../actions/alert';
import {
    buscarCategoriasConfiguracion,
    buscarSubcategoriasConfiguracion,
    buscarUnidades
} from '../../../actions/configuracion';

import {
    crearProductoCatalogoFactura,
    obtenerCodigoProductoFactura,
    limpiarCodigoProductoFactura
} from '../../../actions/facturas';

import { CustomValueContainer } from '../../../components/react_select/ReactSelect';

const styles_select = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    container: (provided) => ({ ...provided }),
    valueContainer: (provided) => ({
        ...provided,
        overflow: 'visible',
        marginTop: '10px'
    }),
    placeholder: (provided, state) => ({
        ...provided,
        position: 'absolute',
        top: state.hasValue || state.selectProps.inputValue ? -15 : '0%',
        transition: 'top 0.1s, font-size 0.1s',
        fontSize: (state.hasValue || state.selectProps.inputValue) && 13
    })
};

const NuevoProductoModal = ({ show, onHide, categoriaDefault, onProductoCreado }) => {
    const dispatch = useDispatch();

    const { listado: listado_unidades } = useSelector((state) => state.configuracion.unidades);
    const { listado: listado_categorias } = useSelector((state) => state.configuracion.categorias);
    const { listado: listado_subcategorias } = useSelector((state) => state.configuracion.subcategorias);
    const { codigo_producto } = useSelector((state) => state.facturas);

    const [statusProcesar, setStatusProcesar] = useState(false);

    const initialProductoData = useMemo(() => ({
        id_categoria: null,
        id_subcategoria: null,
        id_subsubcategoria: null,
        nombre: '',
        fabricante: '',
        reorden: '',
        codigo: '',
        clave_alternativa: '',
        precio_compra: '',
        precio_venta: '',
        descripcion: '',
        unidades: []
    }), []);

    const [productoData, setProductoData] = useState(initialProductoData);

    const [categoriaData, setCategoriaData] = useState(null);
    const [categoriasFilter, setCategoriasFilter] = useState([]);

    const [subcategoriaData, setSubcategoriaData] = useState(null);
    const [subcategoriasFilter, setSubcategoriasFilter] = useState([]);

    const [tiposData, setTiposData] = useState([]);
    const tiposFilter = [
        { value: 1, label: 'Inventario' },
        { value: 3, label: 'Venta' }
    ];

    const [unidadesData, setUnidadesData] = useState([]);
    const [unidadesFilter, setUnidadesFilter] = useState([]);

    const handleAbrir = () => {
        dispatch(buscarUnidades());
        dispatch(buscarCategoriasConfiguracion());
        dispatch(obtenerCodigoProductoFactura());
    };

    const handleInputChange = ({ target }) => {
        setProductoData((prev) => ({
            ...prev,
            [target.name]: target.value
        }));
    };

    const handleSelectCategoria = (option) => {
        setProductoData((prev) => ({
            ...prev,
            id_categoria: option ? option.value : null,
            id_subcategoria: null,
            id_subsubcategoria: null
        }));

        setCategoriaData(option);
        setSubcategoriaData(null);

        if (option?.value) {
            dispatch(buscarSubcategoriasConfiguracion(option.value));
        } else {
            setSubcategoriasFilter([]);
        }
    };

    const handleSelectSubcategoria = (option) => {
        setProductoData((prev) => ({
            ...prev,
            id_subcategoria: option ? option.value : null,
            id_subsubcategoria: null
        }));

        setSubcategoriaData(option);
    };

    const handleAgregarUnidad = () => {
        const unidades = [...(productoData.unidades || [])];

        unidades.push({
            id_unidad: '',
            tipo: '',
            cantidad: ''
        });

        setUnidadesData((prev) => [...prev, null]);
        setTiposData((prev) => [...prev, null]);

        setProductoData((prev) => ({
            ...prev,
            unidades
        }));
    };

    const handleCantidadChange = ({ target }) => {
        const nombre_separado = target.name.split('cantidad_');
        const posicion = Number(nombre_separado[1]);

        const unidades = [...(productoData.unidades || [])];
        if (!unidades[posicion]) return;

        unidades[posicion].cantidad = target.value || '';

        setProductoData((prev) => ({
            ...prev,
            unidades
        }));
    };

    const handleSelectTipo = (option, position) => {
        const unidades = [...(productoData.unidades || [])];
        const tipos = [...tiposData];

        if (!unidades[position]) return;

        unidades[position].tipo = option ? option.value : '';
        tipos[position] = option;

        setTiposData(tipos);

        setProductoData((prev) => ({
            ...prev,
            unidades
        }));
    };

    const handleSelectUnidad = (option, position) => {
        const unidades = [...(productoData.unidades || [])];
        const ids_unidades = [...unidadesData];

        if (!unidades[position]) return;

        unidades[position].id_unidad = option ? option.value : '';
        ids_unidades[position] = option;

        setUnidadesData(ids_unidades);

        setProductoData((prev) => ({
            ...prev,
            unidades
        }));
    };

    const handleEliminarUnidad = ({ currentTarget }) => {
        const id_separado = (currentTarget.id || '').split('_');
        const index = Number(id_separado[1]);

        if (Number.isNaN(index)) return;

        const unidades = [...(productoData.unidades || [])];
        const tipos = [...tiposData];
        const ids_unidades = [...unidadesData];

        unidades.splice(index, 1);
        tipos.splice(index, 1);
        ids_unidades.splice(index, 1);

        setProductoData((prev) => ({
            ...prev,
            unidades
        }));

        setTiposData(tipos);
        setUnidadesData(ids_unidades);
    };

    const handleFilasUnidades = (unidades) => {
        const unidades_campos = [];

        if (unidades && unidades.length) {
            for (let x = 0; x < unidades.length; x++) {
                unidades_campos.push(
                    <div className="col-md-12 form-group mb-3" key={'unidad-row-' + x}>
                        <div className="input-group h-100">
                            <div className="form-floating h-100">
                                <Select
                                    name="tipo"
                                    className="select-group"
                                    classNamePrefix="react-select"
                                    placeholder={'Tipo de unidad ' + (x + 1)}
                                    options={tiposFilter}
                                    value={tiposData[x] || null}
                                    isClearable
                                    onChange={(value) => handleSelectTipo(value, x)}
                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    components={{ ValueContainer: CustomValueContainer }}
                                    styles={{ ...styles_select }}
                                />
                            </div>

                            <div className="form-floating h-100">
                                <Select
                                    name="unidad"
                                    className="select-group"
                                    classNamePrefix="react-select"
                                    placeholder={'Unidad ' + (x + 1)}
                                    options={unidadesFilter}
                                    value={unidadesData[x] || null}
                                    isClearable
                                    onChange={(value) => handleSelectUnidad(value, x)}
                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    components={{ ValueContainer: CustomValueContainer }}
                                    styles={{ ...styles_select }}
                                />
                            </div>

                            <div className="form-floating">
                                <input
                                    type="number"
                                    className="form-control"
                                    placeholder="Cantidad"
                                    id={'cantidad_' + x}
                                    name={'cantidad_' + x}
                                    value={unidades[x].cantidad || ''}
                                    onChange={handleCantidadChange}
                                />
                                <label htmlFor={'cantidad_' + x}>Cantidad {x + 1}</label>
                            </div>

                            <div className="input-group-append">
                                <button
                                    type="button"
                                    className="btn btn-danger delete"
                                    id={'eliminarUnidad_' + x}
                                    onClick={handleEliminarUnidad}
                                >
                                    <i className="fa-solid fa-xmark"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                );
            }
        }

        return unidades_campos;
    };

    const handleProcesar = async () => {
        const nombreValido = productoData.nombre && productoData.nombre.trim() !== '';
        const codigoValido = productoData.codigo && productoData.codigo.trim() !== '';

        if (!nombreValido || !codigoValido) {
            dispatch(setAlert('El nombre y el código son requeridos', 'danger'));
            return;
        }

        const descripcionEnviar =
            productoData.descripcion && productoData.descripcion.trim() !== ''
                ? productoData.descripcion.trim()
                : null;

        const unidadesRaw = Array.isArray(productoData.unidades) ? productoData.unidades : [];

        const unidadesEnviar = unidadesRaw
            .map((u) => ({
                id_unidad: u?.id_unidad ? String(u.id_unidad) : '',
                tipo: u?.tipo !== null && u?.tipo !== undefined && u?.tipo !== '' ? String(u.tipo) : '',
                cantidad: u?.cantidad !== null && u?.cantidad !== undefined && u?.cantidad !== '' ? String(u.cantidad) : ''
            }))
            .filter((u) => u.id_unidad && u.tipo !== '' && u.cantidad !== '');

        if (unidadesRaw.length && unidadesEnviar.length !== unidadesRaw.length) {
            dispatch(setAlert('Completa tipo, unidad y cantidad en todas las unidades o elimínalas.', 'warning'));
            return;
        }

        setStatusProcesar(true);

        const creado = await dispatch(
            crearProductoCatalogoFactura({
                id_categoria: productoData.id_categoria,
                id_subcategoria: productoData.id_subcategoria,
                nombre: productoData.nombre.trim(),
                codigo_tienda: productoData.codigo.trim(),
                descripcion: descripcionEnviar,
                unidades: unidadesEnviar
            })
        );

        setStatusProcesar(false);

        if (!creado?._id) return;

        if (onProductoCreado) onProductoCreado(creado);
        handleCerrar();
    };



    const handleCerrar = () => {
        if (statusProcesar) return;

        setProductoData(initialProductoData);
        setTiposData([]);
        setUnidadesData([]);

        setCategoriaData(null);
        setSubcategoriaData(null);

        dispatch(limpiarCodigoProductoFactura());
        if (onHide) onHide();
    };

    useEffect(() => {
        if (!show) return;

        if (categoriaDefault?.value) {
            setCategoriaData(categoriaDefault);
            setProductoData((prev) => ({
                ...prev,
                id_categoria: categoriaDefault.value,
                id_subcategoria: null
            }));
            dispatch(buscarSubcategoriasConfiguracion(categoriaDefault.value));
        }
    }, [show, categoriaDefault, dispatch]);

    useEffect(() => {
        if (!show) return;
        if (!codigo_producto) return;

        setProductoData((prev) => {
            if (prev.codigo && prev.codigo.trim() !== '') return prev;
            return {
                ...prev,
                codigo: codigo_producto
            };
        });
    }, [codigo_producto, show]);

    useEffect(() => {
        const options = [];
        for (let i = 0; i < (listado_unidades || []).length; i++) {
            options.push({ value: listado_unidades[i]._id, label: listado_unidades[i].nombre });
        }
        setUnidadesFilter(options);
    }, [listado_unidades]);

    useEffect(() => {
        const options = [];
        for (let i = 0; i < (listado_categorias || []).length; i++) {
            options.push({ value: listado_categorias[i]._id, label: listado_categorias[i].nombre });
        }
        setCategoriasFilter(options);
    }, [listado_categorias]);

    useEffect(() => {
        const options = [];
        for (let i = 0; i < (listado_subcategorias || []).length; i++) {
            options.push({ value: listado_subcategorias[i]._id, label: listado_subcategorias[i].nombre });
        }
        setSubcategoriasFilter(options);
    }, [listado_subcategorias]);

    return (
        <Fragment>
            <HelmetProvider>
                <Helmet>
                    <style>{`
                        .select-group { height: 100%; }
                        .delete {
                            padding: 0.39rem 0.70rem !important;
                            border-radius: 0 25% 25% 0 !important;
                            height: 100%;
                        }
                        .btn-morado {
                            background: #6f42c1 !important;
                            border-color: #6f42c1 !important;
                            color: #fff !important;
                        }
                        .btn-morado:hover { filter: brightness(0.95); }
                    `}</style>
                </Helmet>
            </HelmetProvider>

            <Modal
                show={show}
                size="xl"
                backdrop="static"
                centered
                onEntered={handleAbrir}
                onHide={handleCerrar}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Agregar producto</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="row">
                        <div className="col-md-3 form-group mb-2">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Código"
                                        id="codigo"
                                        name="codigo"
                                        value={productoData.codigo}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="codigo">Código</label>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-9 form-group mb-2">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Nombre"
                                        id="nombre"
                                        name="nombre"
                                        value={productoData.nombre}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="nombre">Nombre</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6 form-group mb-2">
                            <div className="input-group h-100">
                                <Select
                                    name="id_categoria"
                                    className="select-group"
                                    classNamePrefix="react-select"
                                    placeholder="Categoría"
                                    options={categoriasFilter}
                                    value={categoriaData}
                                    isClearable
                                    onChange={handleSelectCategoria}
                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    components={{ ValueContainer: CustomValueContainer }}
                                    styles={{ ...styles_select }}
                                />
                            </div>
                        </div>

                        <div className="col-md-6 form-group mb-2">
                            <div className="input-group h-100">
                                <Select
                                    name="id_subcategoria"
                                    className="select-group"
                                    classNamePrefix="react-select"
                                    placeholder="Subcategoría"
                                    options={subcategoriasFilter}
                                    value={subcategoriaData}
                                    isClearable
                                    onChange={handleSelectSubcategoria}
                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    components={{ ValueContainer: CustomValueContainer }}
                                    styles={{ ...styles_select }}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 form-group mb-2">
                            <div className="input-group">
                                <div className="form-floating">
                                    <textarea
                                        className="form-control textareCampo"
                                        placeholder="Descripción"
                                        id="descripcion"
                                        name="descripcion"
                                        value={productoData.descripcion}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="descripcion">Descripción</label>
                                </div>
                            </div>
                        </div>

                        {handleFilasUnidades(productoData.unidades)}
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    {statusProcesar ? (
                        <>
                            <button type="button" className="btn btn-morado" disabled>
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Unidad
                            </button>
                            <button type="button" className="btn btn-success" disabled>
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Agregar
                            </button>
                        </>
                    ) : (
                        <>
                            <button
                                type="button"
                                className="btn btn-morado"
                                onClick={handleAgregarUnidad}
                            >
                                <i className="fas fa-plus fa-sm"></i> Unidad
                            </button>

                            <button
                                type="button"
                                className="btn btn-success"
                                onClick={handleProcesar}
                            >
                                <i className="fas fa-check fa-sm"></i> Agregar
                            </button>
                        </>
                    )}
                </Modal.Footer>
            </Modal>
        </Fragment>
    );
};

export default NuevoProductoModal;
